"use client"

import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "@/lib/auth"

export interface TenantBranding {
  orgName: string
  brandColor: string
  timeZone: string
  dateFormat: string
  hasLogo: boolean
  logoDataUrl: string | null
}

async function fetchBranding(): Promise<TenantBranding> {
  const res = await apiFetch("/api/settings/")
  if (!res.ok) throw new Error(`settings fetch failed: ${res.status}`)
  const org = (await res.json()).organization ?? {}
  let logoDataUrl: string | null = null
  if (org.has_logo) {
    const logoRes = await apiFetch("/api/settings/organization/logo/raw/")
    if (logoRes.ok) {
      const blob = await logoRes.blob()
      logoDataUrl = await new Promise<string>((resolve, reject) => {
        const r = new FileReader()
        r.onload = () => resolve(r.result as string)
        r.onerror = reject
        r.readAsDataURL(blob)
      })
    }
  }
  return {
    orgName: org.org_name || "",
    brandColor: org.brand_color || "#0F1F5C",
    timeZone: org.timezone || "UTC",
    dateFormat: org.date_format || "YYYY-MM-DD",
    hasLogo: Boolean(org.has_logo),
    logoDataUrl,
  }
}

export const TENANT_BRANDING_KEY = ["tenant-branding"] as const

export function useTenantBranding() {
  return useQuery({ queryKey: TENANT_BRANDING_KEY, queryFn: fetchBranding, staleTime: 5 * 60_000 })
}
